export default function HeroVisual() {
  return (
    <div className="visual-shell min-h-[520px]">
      <div className="floating-dot -left-10 top-6 h-24 w-24" />
      <div className="floating-dot right-8 top-12 h-16 w-16" />
      <div className="floating-dot bottom-0 right-0 h-36 w-36" />

      <div className="relative z-10 flex h-full flex-col justify-between gap-6">
        <div className="flex flex-wrap gap-2">
          <span className="chip-dark">🎓 Admissions</span>
          <span className="chip-dark">📘 Boards</span>
          <span className="chip-dark">⚡ Live Doubts</span>
        </div>

        <div className="grid gap-5 md:grid-cols-[0.95fr_1.05fr]">
          <div className="glow-card p-5">
            <p className="text-xs font-extrabold uppercase tracking-[0.22em] text-white/55">
              Progress Snapshot
            </p>
            <div className="mt-5 space-y-4">
              {[
                { label: "Attendance", value: 92 },
                { label: "Mock Score", value: 84 },
                { label: "Homework", value: 76 },
              ].map((item) => (
                <div key={item.label} className="space-y-2">
                  <div className="flex items-center justify-between text-xs font-semibold text-white/75">
                    <span>{item.label}</span>
                    <span>{item.value}%</span>
                  </div>
                  <div className="h-2 rounded-full bg-white/10">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-skyglow to-emerald-400"
                      style={{ width: `${item.value}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative flex items-center justify-center overflow-hidden rounded-[28px] border border-white/12 bg-white/10 p-6">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.14),transparent_54%)]" />
            <div className="absolute left-6 top-8 animate-floaty rounded-full border border-white/12 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white/80">
              🧑‍🏫 1:1 tutoring
            </div>
            <div className="absolute right-5 top-24 animate-floaty rounded-full border border-white/12 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white/80 [animation-delay:0.8s]">
              📊 Weekly progress
            </div>
            <div className="absolute bottom-12 left-8 animate-floaty rounded-full border border-white/12 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white/80 [animation-delay:1.4s]">
              🧩 Weekly mocks
            </div>

            <div className="relative grid h-56 w-56 place-items-center rounded-full border border-white/12 bg-[radial-gradient(circle_at_top,rgba(21,212,255,0.28),rgba(255,255,255,0.02))] shadow-[0_0_90px_rgba(21,212,255,0.24)]">
              <div className="grid h-40 w-40 place-items-center rounded-full border border-white/12 bg-white/10 text-6xl shadow-[0_0_60px_rgba(255,179,71,0.22)]">
                <span aria-hidden="true">&#127891;</span>
              </div>
            </div>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-3">
          {[
            "✅ 500+ verified tutors",
            "💬 WhatsApp-first booking",
            "🏆 Board and entrance plans",
          ].map((item, index) => (
            <div
              key={item}
              className="rounded-[24px] border border-white/10 bg-white/10 px-4 py-4 text-sm font-semibold text-white/82"
              style={{ animationDelay: `${index * 0.3}s` }}
            >
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
